import { render, staticRenderFns } from "./OfferingsDashboard.vue?vue&type=template&id=01333892&scoped=true"
import script from "./OfferingsDashboard.vue?vue&type=script&lang=js"
export * from "./OfferingsDashboard.vue?vue&type=script&lang=js"
import style0 from "./OfferingsDashboard.vue?vue&type=style&index=0&id=01333892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01333892",
  null
  
)

export default component.exports